import { Component } from '@angular/core'
import { MatTabsModule } from '@angular/material/tabs'
import { PurchaseReservationTgComponent } from '../../features/purchase-reservation/purchase-reservation-tg/purchase-reservation-tg.component'
import { PurchaseReservationServiceOrderComponent } from '../../features/purchase-reservation/purchase-reservation-service-order/purchase-reservation-service-order.component'

@Component({
  selector: 'purchase-reservation',
  imports: [
    MatTabsModule,
    PurchaseReservationTgComponent,
    PurchaseReservationServiceOrderComponent,
  ],
  templateUrl: './purchase-reservation.component.html',
  styleUrl: './purchase-reservation.component.scss',
  standalone: true,
})
export class PurchaseReservationComponent {}
